import { createActionGroup, props } from '@ngrx/store';
import { ConfigurationProfile } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceResolverActions = createActionGroup({
  source: 'Apple Device Resolver',
  events: {
    'Profiles requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// CONTAINER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceContainerActions = createActionGroup({
  source: 'Apple Device Container',
  events: {
    'Profiles requested': props<{ udid: string }>(),
    'Single App Mode changed': props<{ udid: string; bundleIdentifier: string; locked: boolean }>(),
  },
});

export const AppleCurrentDeviceContainerActions = createActionGroup({
  source: 'Apple Current Device Container',
  events: {
    'Single App Mode changed': props<{ udid: string; bundleIdentifier: string; locked: boolean }>(),
  },
});

// ============================================================================
// EFFECTS ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmAppleProfileEffectsActions = createActionGroup({
  source: 'MDM Apple Profile Effects',
  events: {
    'Profile added': props<{ udid: string; profile: ConfigurationProfile }>(),
    'Profile removed': props<{ udid: string; profileIdentifier: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmAppleDevicesApiActions = createActionGroup({
  source: 'MDM Apple Devices API',
  events: {
    'Profiles loaded': props<{ udid: string; profiles: ConfigurationProfile[] }>(),
    'Profiles loaded error': props<{ error: ErrorModel }>(),
  },
});
